import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description UserProtector icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { UserProtector } from '@sravni/design-system-icons'
 *
 * <UserProtector />
 * ```
 */
var UserProtector = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "UserProtector", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.786 16.428V15a2.857 2.857 0 0 1 2.857-2.857H8.5M8.5 9.286a2.857 2.857 0 1 0 0-5.715 2.857 2.857 0 0 0 0 5.715ZM18 13.544c0 2.061-1.493 3.988-3.5 4.456-2.007-.468-3.5-2.395-3.5-4.456v-1.619c0-.368.215-.7.544-.84l2.187-.928a1.961 1.961 0 0 1 1.538 0l2.187.928c.33.14.544.472.544.84v1.62Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { UserProtector };
//# sourceMappingURL=UserProtector.js.map
